module.exports = __webpack_public_path__ + "media/images/airtel-8bf1760a52cb8441f6939f135cb0598f.png";